
import { isWeChat, isNfPlus, isWeChatMiniProgram, isInDkgdhMiniApp } from '@/utils/env'
import { Toast } from 'vant'
import getUrlParams from '@/utils/getUrlParams'
import { handleJumpToDkgdh } from '@/utils/miniapp-handles/dkgdh'

export default {
  methods: {
    handleClick () {
      if (this.toMp) {
        const { appId, originalAppId } = this.pavilion
        // 20250603：兼容旧数据；旧数据把originalId保存成了appId字段
        const isOldData = appId && appId.indexOf('gh_') === 0
        const realOriginalId = isOldData ? appId : originalAppId
        const realAppId = isOldData ? '' : appId
        // 端内直接跳转
        if (isNfPlus()) {
          if (realOriginalId) {
            window.nfplusJsbridge.openMiniProgram({
              name: this.pavilion.childrenExhibitionName,
              colWxtoolID: realOriginalId,
              miniprogramType: 0,
              colWxtool2Url: this.pavilion.appUrl,
            })
          } else {
            Toast('请在微信中打开此链接')
          }
        } else if (isWeChatMiniProgram() && window.location.href.indexOf('mpOriginalId') > -1) {
          // 小程序内&&携带mpOriginalId，证明是需要在小程序里面跳转的
          // 根据传入的原始id，判断是不是要跳转当前小程序的页面；如果相等，就是跳转当前小程序的，如果不相等，就是要跳第三方小程序的，需要先跳中间页
          const mpOriginalId = getUrlParams().mpOriginalId
          if (realAppId) {
            // 跳原本小程序
            if (realOriginalId === mpOriginalId) {
              if (isInDkgdhMiniApp(realOriginalId)) {
                handleJumpToDkgdh(this.pavilion.appUrl)
              } else {
                // 其他小程序统一这样处理【后续新接入的可能要判断使用navigateTo还是switchTo】
                window.wx.miniProgram.navigateTo({
                  url: this.pavilion.appUrl,
                  fail: () => {
                    Toast('请在微信中打开此链接')
                  },
                })
              }
            } else {
              // 需要跳转第三方，先跳转中间页
              window.wx.miniProgram.navigateTo({
                url: `/pages/tools/middle-page/index?data=${encodeURIComponent(JSON.stringify({ appId: this.pavilion.appId, path: this.pavilion.appUrl, appName: this.pavilion.childrenExhibitionName }))}`,
              })
            }
          } else {
            Toast('请在微信中打开此链接')
          }
        } else if (!isWeChat()) {
          Toast('请在微信中打开此链接')
        }
      }
      this.$emit('click')
    },
  },
}
